export function copy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export function splitArray2Parts(arr, size) {
	const result = [];
	for (let i = 0; i < arr.length; i += size) {
		result.push(arr.slice(i, i + size));
	}
	return result;
}

export function camelCase(name) {
	return name.substr(0, 1).toLowerCase() + name.substr(1);
}

export class UrlBuilder {
	constructor(url) {
		this.url = url;
		this.paramList = [];
	}

	append(name, value) {
		if (isNotEmpty(value)) {
			this.paramList.push({ name: name, value: value });
		}
		return this;
	}

	build() {
		this.paramList.forEach((e, i, a) => {
			if (i === 0) {
				this.url += "?";
			} else {
				this.url += "&";
			}
			this.url += e.name + "=" + e.value;
		});
		return this.url;
	}
}

export function isNotEmpty(val) {
	return val !== undefined && val !== null && val !== "";
}

export function isEmpty(val) {
	return val === undefined || val === null || val === "";
}

export function prepareUrl(url) {
	return new UrlBuilder(url);
}

export function debounce(fn, delay = 500) {
	let timer;
	return e => {
		e.persist();
		clearTimeout(timer);
		timer = setTimeout(() => {
			fn(e);
		}, delay);
	};
}

export function throttle(fn, delay, atleast) {
	let timeout = null,
		startTime = new Date();
	return function () {
		let curTime = new Date();
		clearTimeout(timeout);
		if (curTime - startTime >= atleast) {
			fn();
			startTime = curTime;
		} else {
			timeout = setTimeout(fn, delay);
		}
	};
}

export function clickUrl(url) {
	const httpLink = document.createElement("a");
	httpLink.href = url;
	httpLink.target = "_blank";
	httpLink.click();
}

export function escape2Html(str) {
	var temp = document.createElement("div");
	temp.innerHTML = str;
	var output = temp.innerText || temp.textContent;
	temp = null;
	return output;
}

export function formDataToObject(formData) {
	const object = {};
	formData.forEach((value, key) => {
		// 如果表单中有多个相同名称的字段（例如，复选框），则这些值将存储在数组中
		if (object[key]) {
			if (Array.isArray(object[key])) {
				object[key].push(value);
			} else {
				object[key] = [object[key], value];
			}
		} else {
			object[key] = value;
		}
	});
	return object;
}

// 生成480x480等比例缩略图并获取base64编码
export function generateThumbnailBase64(file) { 
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = event => {
			const img = new Image();
			img.onload = () => {
				// 创建canvas元素用于生成缩略图
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");

				// 设置目标尺寸为480x480
				const targetSize = 480;

				// 计算缩略图尺寸（保持等比例）
				let width, height, x, y;
				if (img.width > img.height) {
					// 宽图
					width = targetSize;
					height = (img.height * targetSize) / img.width;
					x = 0;
					y = (targetSize - height) / 2;
				} else {
					// 高图或正方形图
					height = targetSize;
					width = (img.width * targetSize) / img.height;
					x = (targetSize - width) / 2;
					y = 0;
				}

				// 设置canvas尺寸
				canvas.width = targetSize;
				canvas.height = targetSize;

				// 填充背景色（可选，这里使用白色）
				ctx.fillStyle = "#FFFFFF";
				ctx.fillRect(0, 0, targetSize, targetSize);

				// 绘制缩略图
				ctx.drawImage(img, x, y, width, height);

				// 获取base64编码
				const base64 = canvas.toDataURL("image/jpeg", 0.8);
				resolve(base64);
			};
			img.onerror = reject;
			img.src = event.target.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}